import React, { useEffect, useState, Fragment } from 'react';
import styled from 'styled-components';
import { COLOR } from '~~elements/Const';
import { GameSectionDiv } from '../styled';
import BoxScoreUpload from './BoxScoreUpload';
import PbPUpload from './PbPUpload';

const StyledDiv = styled.div`
  width: 100%;
  .admin-only {
    &--title {
      font-size: 1.1rem;
      margin: 0;
      padding: 0.5rem 0 0.2rem;
      border-bottom: 1px solid ${COLOR.secondary};
      display: inline-block;
    }
    &--content {
      width: 100%;
      display: block;
      overflow-x: auto;
    }
  }

  table {
    border-collapse: collapse;
  }
  table,
  th,
  td {
    border: 1px solid #eee;
  }

  td {
    padding: 0.2rem 0.3rem;
  }
`;

// 只有 Rebas 管理員才能使用
const GameAdminSection = ({ awayTeamPlayers, homeTeamPlayers, gameWithPlayers }) => {
  const [tablizePlayers, setTablizePlayers] = useState([]);

  useEffect(() => {
    const rowAmount = Math.max(awayTeamPlayers.length, homeTeamPlayers.length);
    setTablizePlayers(
      new Array(rowAmount).fill('').map((_, index) => {
        const emptyPlayer = (
          <Fragment>
            <td></td>
            <td></td>
          </Fragment>
        );

        const awayPlayer = !awayTeamPlayers[index] ? (
          emptyPlayer
        ) : (
          <Fragment>
            <td>{awayTeamPlayers[index].number}</td>
            <td>{awayTeamPlayers[index].name}</td>
          </Fragment>
        );
        const homePlayer = !homeTeamPlayers[index] ? (
          emptyPlayer
        ) : (
          <Fragment>
            <td>{homeTeamPlayers[index].number}</td>
            <td>{homeTeamPlayers[index].name}</td>
          </Fragment>
        );

        return (
          <tr key={index}>
            {awayPlayer}
            {homePlayer}
          </tr>
        );
      }),
    );
  }, [awayTeamPlayers, homeTeamPlayers]);

  return (
    <GameSectionDiv>
      <h3 className="section--title">Rebas 管理員專用</h3>
      <div className="section--description">請注意！主辦方管理者無法使用這介面</div>
      <StyledDiv>
        <h4 className="admin-only--title">Excel 用球員名單（可複製貼上）</h4>
        <div className="admin-only--content">
          <table>
            <tbody>
              <tr>
                <td>{gameWithPlayers.away.team}</td>
                <td />
                <td>{gameWithPlayers.home.team}</td>
                <td />
              </tr>
              <tr>
                <td>背號</td>
                <td>姓名</td>
                <td>背號</td>
                <td>姓名</td>
              </tr>
              {tablizePlayers.map((tablizePlayer) => tablizePlayer)}
            </tbody>
          </table>
        </div>
        <h4 className="admin-only--title">Box Score Excel 表上傳</h4>
        <div className="admin-only--content">
          <BoxScoreUpload
            awayTeamPlayers={awayTeamPlayers}
            homeTeamPlayers={homeTeamPlayers}
            gameWithPlayers={gameWithPlayers}
          />
        </div>
        <h4 className="admin-only--title">逐打席 PbP Excel 表上傳</h4>
        <div className="admin-only--content">
          <PbPUpload
            awayTeamPlayers={awayTeamPlayers}
            homeTeamPlayers={homeTeamPlayers}
            gameWithPlayers={gameWithPlayers}
          />
        </div>
      </StyledDiv>
    </GameSectionDiv>
  );
};

export default GameAdminSection;
